import { SynchronizationExecutionStateEnum } from 'src/app/shared/enums/synchronization-execution-state.enum';

export interface LastSuccessfulSynchronizationItem {
  labelKey: string;
  synchronizedRecords: number;
  status: SynchronizationExecutionStateEnum;
  errorMessage?: string;
}

export class LastSuccessfulSynchronization {
  userEmail: string;
  executedAt: Date;
  items: LastSuccessfulSynchronizationItem[];

  constructor(data: {
    userEmail: string;
    executedAt: Date;
    items: LastSuccessfulSynchronizationItem[];
  }) {
    this.userEmail = data.userEmail;
    this.executedAt = data.executedAt;
    this.items = data.items;
  }
}
